import clsx from 'clsx'

/**
 * Solari split-flap board primitives -- shared so every dark depot/corridor board in the
 * console (MBMT's Arrivals & departures, Ultratech's Arrivals) renders the same mechanical
 * character-flip, rather than each screen re-implementing its own animation.
 */

/** Solari flap-cell face: a dark split leaf with the hinge shadow baked in. */
export const CELL_BG =
  'linear-gradient(180deg,#2A3A5C 0%,#22304E 47%,#141F38 53%,#1A2742 100%)'

export const AMBER = '#FBBF24'
export const GREEN = '#34D399'
export const RED = '#F87171'
export const WHITE = '#E8EDF6'
export const MUTED = '#64748B'

export function FlapChar({ ch, delay = 0, tone = WHITE, small }: {
  ch: string
  delay?: number
  tone?: string
  small?: boolean
}): JSX.Element {
  return (
    <span
      className={clsx(
        'relative grid place-items-center overflow-hidden rounded-[3px] [perspective:220px]',
        small ? 'h-[20px] w-[13px]' : 'h-[28px] w-[19px]',
      )}
      style={{ background: CELL_BG }}
    >
      {/* key={ch}: a changed character remounts the leaf, which falls in from edge-on --
          the split-flap drop -- while unchanged neighbours hold still. */}
      <span
        key={ch}
        className={clsx(
          'animate-flap-in font-mono font-bold leading-none',
          small ? 'text-[11px]' : 'text-[15px]',
        )}
        style={{ color: tone, animationDelay: `${delay}ms` }}
      >
        {ch === ' ' ? ' ' : ch}
      </span>
      <span className="pointer-events-none absolute left-0 right-0 top-1/2 h-px bg-black/45" />
    </span>
  )
}

export function FlapText({ text, width, tone, small, stagger = 26 }: {
  text: string
  width: number
  tone?: string
  small?: boolean
  stagger?: number
}): JSX.Element {
  const chars = text.toUpperCase().padEnd(width).slice(0, width).split('')
  return (
    <span className="flex gap-[2px]">
      {chars.map((c, i) => (
        <FlapChar key={i} ch={c} delay={i * stagger} tone={tone} small={small} />
      ))}
    </span>
  )
}
